module.exports = __webpack_public_path__ + "img/uk.5b9ffff9.png";